import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { colors } from '../../../../../../../../../colorVars';
import { HoverBox } from '../../../hoverBox/HoverBox';
import { modifySoftOrderProvideDetails } from '../../../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/modifySoftOrders';
import { PendingTargetCancelControl } from './PendingTargetCancelControl';

// renders one line for a watched (not-yet-placed) TastyTrade target - the reactive-target fix means
// these have no real broker order until they fire, so they're invisible to the order-stream-driven
// OrderLine/MiniOrdersTable path. Green, same as a real resting target line would have looked, with
// its own cancel affordance (not HoverBox - see PendingTargetCancelControl).
export const PendingTargetLine = ({
  targetPrice,
  qty,
  cancelKey,
  cancelKeyType,
  completeSoftOrder,
  size,
  scaleY,
  portalRef,
}) => {
  const [hovered, setHovered] = useState(false);
  if (!scaleY) return null;

  const price = Number(targetPrice);
  const yPos = scaleY(price);

  const handleCancel = () => {
    modifySoftOrderProvideDetails({
      softOrder: completeSoftOrder,
      details: {
        cancelPendingTarget: {
          ...(cancelKeyType === 'price' ? { price: cancelKey } : { level: cancelKey }),
          pluginId: completeSoftOrder?.value?.tacticId,
        },
      },
    });
  };

  return (
    <g
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <line
        stroke={colors.green}
        strokeWidth={1}
        x1={0}
        x2={size}
        y1={yPos}
        y2={yPos}
      />
      <HoverBox
        json={{
          Category: 'Exit Tactic',
          Type: 'Pending Target',
          Price: price,
          Quantity: qty,
        }}
        topBoundary={yPos - 2}
        bottomBoundary={yPos + 2}
        leftBoundary={0}
        rightBoundary={size}
        portalRef={portalRef}
        size={size}
        linePrice={price}
      />
      <PendingTargetCancelControl
        x={size - 16}
        y={yPos}
        visible={hovered}
        onCancel={handleCancel}
      />
    </g>
  );
};

PendingTargetLine.propTypes = {
  targetPrice: PropTypes.number.isRequired,
  qty: PropTypes.number,
  cancelKey: PropTypes.oneOfType([PropTypes.number]).isRequired,
  cancelKeyType: PropTypes.oneOf(['level', 'price']).isRequired,
  completeSoftOrder: PropTypes.object,
  size: PropTypes.number,
  scaleY: PropTypes.func,
  portalRef: PropTypes.object,
};
